
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { TimedAccessProvider } from "@/context/TimedAccessContext";
import PageTrackingLayout from "@/layouts/PageTrackingLayout";
import AnnouncementBar from "@/components/AnnouncementBar";
import Index from "@/pages/Index";
import Learn from "@/pages/Learn";
import GetPremium from "@/pages/GetPremium";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Profile from "@/pages/Profile";
import Settings from "@/pages/Settings";
import ArticlePage from "@/pages/ArticlePage";
import NotFound from "@/pages/NotFound";
import About from "@/pages/About";
import MockInterview from "@/pages/MockInterview";
import Coaching from "@/pages/Coaching";
import BookCoaching from "@/pages/BookCoaching";
import MLFundamentals from "@/pages/MLFundamentals";
import MLTheoryAstro from "@/pages/MLTheoryAstro";
import DocsIndex from "@/pages/docs/index";
import EmailCampaign from "@/pages/EmailCampaign";
import Analytics from "@/pages/admin/Analytics";

// Article pages
import ArticleRecommendationSystems from "@/pages/articles/ArticleRecommendationSystems";
import ArticleYouTubeRecommendationSystem from "@/pages/articles/ArticleYouTubeRecommendationSystem";
import ArticleCandidateGeneration from "@/pages/articles/ArticleCandidateGeneration";
import ArticleHarmfulContentDetection from "@/pages/articles/ArticleHarmfulContentDetection";
import ArticleAdsRanking from "@/pages/articles/ArticleAdsRanking";
import ArticleAdsCalibration from "@/pages/articles/ArticleAdsCalibration";
import ArticleBiases from "@/pages/articles/ArticleBiases";
import ArticleUserBehaviourSequence from "@/pages/articles/ArticleUserBehaviourSequence";
import ArticleFaangInterviews from "@/pages/articles/ArticleFaangInterviews";
import ArticleFaangInterviewsPart2 from "@/pages/articles/ArticleFaangInterviewsPart2";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <TimedAccessProvider>
          <Router>
            <PageTrackingLayout>
              <AnnouncementBar />
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/learn" element={<Learn />} />
                <Route path="/get-premium" element={<GetPremium />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/about" element={<About />} />
                <Route path="/mock-interview" element={<MockInterview />} />
                <Route path="/coaching" element={<Coaching />} />
                <Route path="/book-coaching" element={<BookCoaching />} />
                <Route path="/ml-fundamentals" element={<MLFundamentals />} />
                <Route path="/ml-theory" element={<MLTheoryAstro />} />
                <Route path="/docs" element={<DocsIndex />} />
                <Route path="/article/:slug" element={<ArticlePage />} />
                <Route path="/admin/analytics" element={<Analytics />} />
                <Route path="/email-campaign" element={<EmailCampaign />} />
                
                {/* Article routes */}
                <Route path="/articles/recommendation-systems" element={<ArticleRecommendationSystems />} />
                <Route path="/articles/youtube-recommendation-system" element={<ArticleYouTubeRecommendationSystem />} />
                <Route path="/articles/candidate-generation" element={<ArticleCandidateGeneration />} />
                <Route path="/articles/harmful-content-detection" element={<ArticleHarmfulContentDetection />} />
                <Route path="/articles/ads-ranking" element={<ArticleAdsRanking />} />
                <Route path="/articles/ads-calibration" element={<ArticleAdsCalibration />} />
                <Route path="/articles/biases" element={<ArticleBiases />} />
                <Route path="/articles/user-behaviour-sequence-modelling" element={<ArticleUserBehaviourSequence />} />
                <Route path="/articles/faang-ml-interviews" element={<ArticleFaangInterviews />} />
                <Route path="/articles/faang-ml-interviews-part2" element={<ArticleFaangInterviewsPart2 />} />
                
                <Route path="*" element={<NotFound />} />
              </Routes>
            </PageTrackingLayout>
          </Router>
        </TimedAccessProvider>
      </AuthProvider>
      <Toaster />
    </QueryClientProvider>
  );
}

export default App;
